import React, { FC } from 'react';
import Grid from 'styled-components-grid';
import { FaTable, FaFileAlt, FaFileImage, FaFilePdf, FaFileArchive, FaFile } from 'react-icons/fa';
import { media, Text } from '@morressier/ts';
import { getFileExtension, getFileFromUrl } from 'utils/misc';
import styled, { css } from 'styled-components';
import * as Styles from './styles';

const IconContainer = styled(Grid.Unit).attrs(() => ({ size: 2 / 8 }))`
  background-color: rgb(240, 241, 242);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FileNameContainer = styled(Grid.Unit).attrs(() => ({ size: 6 / 8 }))`
  display: flex;
  align-items: center;
  padding: 0 1rem 0 2rem;
`;

const iconSize = css`
  width: 1rem;
  height: 2rem;
  ${media.medium`
    width: 2rem;
    height: 3.5rem;
  `}
`;

const StyledFaFilePdf = styled(FaFilePdf)`
  ${iconSize}
`;

const StyledFaTable = styled(FaTable)`
  ${iconSize}
`;

const StyledFaFileAlt = styled(FaFileAlt)`
  ${iconSize}
`;
const StyledFaFileImage = styled(FaFileImage)`
  ${iconSize}
`;
const StyledFaFileArchive = styled(FaFileArchive)`
  ${iconSize}
`;
const StyledFaFile = styled(FaFile)`
  ${iconSize}
`;

const CardContent = styled.div`
  border: 1px solid rgb(212, 213, 214);
  border-radius: 3px;
  width: 100%;
  height: 4rem;
  display: flex;
  ${media.medium`
      height: 7rem;
    `}
`;

const getFileIcon = (fileExtension: string) => {
  const tabularDataExtensions = ['xls', 'xlsx', 'ods', 'pages', 'csv'];
  const textDocumentExtensions = ['doc', 'docx', 'odt', 'rtf', 'txt'];
  const imageExtensions = ['jpg', 'jpeg', 'tiff', 'png', 'bmp'];
  const archiveExtensions = ['zip', 'rar'];

  if (tabularDataExtensions.includes(fileExtension)) {
    return <StyledFaTable />;
  } if (textDocumentExtensions.includes(fileExtension)) {
    return <StyledFaFileAlt />;
  } if (imageExtensions.includes(fileExtension)) {
    return <StyledFaFileImage />;
  } if (fileExtension === 'pdf') {
    return <StyledFaFilePdf />;
  } if (archiveExtensions.includes(fileExtension)) {
    return <StyledFaFileArchive />;
  } 
    return <StyledFaFile />;
};

const DatasetsSection: FC<{ poster: MorressierPoster }> = props => {
  const { poster } = props;

  const zeroState = (
    <Styles.ZeroStateBox>
      <Styles.ZeroStateBoxWrapper>
        <FaFile size="3rem" style={{ marginBottom: '1rem' }} />
        <Text color="grey" style={{ textAlign: 'center' }}>
          No datasets are available for this submission.
        </Text>
      </Styles.ZeroStateBoxWrapper>
    </Styles.ZeroStateBox>
  );

  return !poster.additional_file_urls || poster.additional_file_urls.length === 0 ? (
    zeroState
  ) : (
    <>
      {poster.additional_file_urls.map(fileUrl => {
        const fileExtension = getFileExtension(fileUrl);
        const FileIcon = getFileIcon(fileExtension);
        const fileName = getFileFromUrl(fileUrl);

        return (
          <Grid key={fileUrl} style={{ marginBottom: '1rem' }}>
            <Grid.Unit size={{ xlarge: 8 / 12 }}>
              <Styles.Card href={fileUrl} target="_blank" rel="noopener noreferrer">
                <CardContent>
                  <IconContainer>{FileIcon}</IconContainer>

                  <FileNameContainer>
                    <Text
                      style={{
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                      }}
                    >
                      {decodeURI(fileName)}
                    </Text>
                  </FileNameContainer>
                </CardContent>
              </Styles.Card>
            </Grid.Unit>
          </Grid>
        );
      })}
    </>
  );
};

export default DatasetsSection;
